import React from "react";
import {observer} from "mobx-react";
import './modal.scss'
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";
import {WarningIcon} from "../../assets/svg-icons/WarningIcon";
import * as serverEnums from "../../serverClientShared/sharedEnums";

const HideHelpButtonModal = observer(() => {
    const {modalStore, generalStore} = useStores();

    function closeModal() {
        modalStore.isHideHelpButtonModalOpen = false;
        modalStore.resetModalData();
    }

    async function hideHelpButton() {
        try {
            generalStore.isLoaderOpen = true;
            const responseCode = await generalStore.updateUser({
                Email: generalStore.userDetails.Email,
                DisableHelpButton: true
            });
            if (responseCode !== serverEnums.responseEnum.OK) {
                throw new Error('error:' + responseCode);
            }
            await generalStore.refreshCurrentUser();
            generalStore.isLoaderOpen = false;
            closeModal();
        } catch (e) {
            modalStore.showErrorMessage(generalStore.translate('problemHidingHelpButton'));
            console.error(e);
        }
        generalStore.isLoaderOpen = false;
    }

    return (
        <GeneralDialog
            openControl='isHideHelpButtonModalOpen'
            className='open-style-dialog delete-open-style'
            onEnter={null}
            title={<><WarningIcon/><h2>{generalStore.translate("hideHelpButton")}</h2></>}
            body={<div className="dialog-description">{generalStore.translate("hideTheHelpButton")}? {generalStore.translate("thisOptionCanBeChangedInUserSettings")}</div>}
            isConfirmDisabled={false}
            onConfirm={hideHelpButton}
            confirmText={generalStore.translate('hide')}
            buttonClass={'warning'}
        />
    );
});

export default HideHelpButtonModal;
